import React from 'react';
import {ReactComponent as Icon} from 'images/icon/effectiveness/thumb-down.svg';
import {ReactComponent as IconInverted} from 'images/icon/effectiveness/thumb-down-inverted.svg';

export default function ThumbDownIcon({inverted}) {
  return inverted ? (
    <IconInverted className="icon thumb-down" />
  ) : (
    <Icon className="icon thumb-down" />
  );
}
